import { createApi } from '@reduxjs/toolkit/query/react';

import { API_CONSTANTS } from '../../utils/constants';
import { baseQueryWithReauth } from '../../apis/baseQuery';
import { ApiResponse } from '../../model';

export const profileApi = createApi({
  reducerPath: 'profileApi',
  tagTypes: ['Profile'],
  baseQuery: baseQueryWithReauth,
  keepUnusedDataFor: 600,
  endpoints: (builder) => ({
    fetchUserDetails: builder.query<ApiResponse<any>, void>({
      query: () => API_CONSTANTS.IDENTITY_ENDPOINT,
    }),
    updateProfile: builder.mutation<ApiResponse<any>, any>({
      query: (formData) => ({
        url: API_CONSTANTS.PROFILE_UPDATE_ENDPOINT,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['Profile'],
    }),
    updateProfilePassword: builder.mutation<ApiResponse<any>, any>({
      query: (formData) => ({
        url: API_CONSTANTS.CHANGE_PASSWORD_ENDPOINT,
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const {
  useFetchUserDetailsQuery,
  useUpdateProfileMutation,
  useUpdateProfilePasswordMutation,
} = profileApi;
